module.exports = __webpack_public_path__ + "media/images/icons/subject_knowledge-2f494ef96ef04edd69ffe56c76a48281.svg";